// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import Finito from "./../../services/finito-service";
import BaoDialog from "./../../factories/bao-dialog";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-searcher";
function OrgUnitAreaViewModel(tabPage, orgUnitViewModel) {
    var self = this;
    self.TabPage = tabPage;
    self.OrgUnitViewModel = orgUnitViewModel;
    self.Selection = ko.observableArray();
    self.SelectedAreas = ko.observableArray();
    self.Sorting = ko.observableArray();
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.Models = ko.observableArray([]);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.Selection.subscribe(function () {
        self.toggleButtons();
    });
    self.SelectedAreas.subscribe(function (selectedItems) {
        if (selectedItems != null && selectedItems.length > 0) {
            var areaIds = [];
            ko.utils.arrayForEach(selectedItems, function (item: any) {
                areaIds.push(ko.unwrap(item.AreaId));
            });
            self.addAreaToSession(areaIds);
        }
    });
    self.toolbarButtonClicked = function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            var functionString = btn.ActionKey().substr(("OrgUnitCustomToolbarArea").length);
            switch (functionString) {
                case "Add":
                    self.addArea();
                    break;
                case "Remove":
                    var promptDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DeleteOrgUnitArea"), "question");
                    promptDialog.DialogResult.subscribe(function (res) {
                        if (res) {
                            self.removeArea();
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    };
    self.toolbarLoaded = function () {
        self.toggleButtons();
    };
    self.addArea = function (item) {
        this.openAreaSearcher();
    };
    self.openAreaSearcher = function () { };
}
;
OrgUnitAreaViewModel.prototype.toggleButtons = function () {
    if (this.enableButton != undefined) {
        var selection = this.Selection.peek();
        this.enableButton("OrgUnitCustomToolbarAreaRemove", selection && selection.length > 0);
    }
};
OrgUnitAreaViewModel.prototype.removeArea = function (a, b, c) {
    var self = this;
    self.TabPage.IsLoading(true);
    var areaIds = [];
    ko.utils.arrayForEach(self.Selection(), function (item: any) {
        areaIds.push(ko.unwrap(item.AreaId));
    });
    return Bao.post("OrgUnit/DeleteArea", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        areaIds: areaIds
    }), function () {
        self.OrgUnitViewModel.TabPage.DirtyFlag(true);
        self.RefreshGrid();
    });
};
OrgUnitAreaViewModel.prototype.RefreshGrid = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("OrgUnit/GetArea", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting()
    }), function (searchResult) {
        self.SelectedAreas([]);
        self.TotalRows(0);
        self.Models([]);
        if (searchResult != null && searchResult.Models != null) {
            self.Models(searchResult.Models);
            self.TotalRows(searchResult.TotalRows);
            self.toggleButtons();
        }
        self.TabPage.IsLoading(false);
    });
};
OrgUnitAreaViewModel.prototype.Refresh = function () {
    var self = this;
    var def = $.Deferred();
    self.Selection([]);
    Bao.post("OrgUnit/ResetAreaOrgUnit", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId()
    }), function () {
        self.RefreshGrid().then(function () {
            def.resolve();
        });
    });
    return def.promise();
};
OrgUnitAreaViewModel.prototype.addAreaToSession = function (areaIds) {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("OrgUnit/AddArea", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        areaIds: areaIds
    }), function () {
        self.OrgUnitViewModel.TabPage.DirtyFlag(true);
        self.RefreshGrid();
    });
};
export default OrgUnitAreaViewModel;